import { useQuery } from "react-query";
import http from "infra/http";

import {
  MensagemRecebidaUnidadeFiltro,
  ListagemMensagemResponse,
} from "../typings";

function useMensagensRecebidaUnidade(filtro: MensagemRecebidaUnidadeFiltro, enabled = true) {
  return useQuery(
    `/v1/mensagem/por-unidade/${filtro.unidadeId}-${filtro.page}-${filtro.limit}-${filtro.search}`,
    async () => {
      const { data } = await http.get<ListagemMensagemResponse>(
        `/v1/mensagem/por-unidade/${filtro.unidadeId}`,
        {
          params: filtro,
        }
      );
      return data;
    },
    {
      enabled: !!filtro.unidadeId && enabled,
    }
  );
}

export default useMensagensRecebidaUnidade;
